import React, { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Grid, IconButton, InputAdornment } from '@mui/material';
import TextFieldContext from 'components/CustomInputsInFormikContext/TextField';
import CardWrapper from 'components/Financial/CardWrapper';

function AccessData() {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <CardWrapper title="Dados de Acesso">
      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext disabled label="Email" type="email" name="email" />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          InputLabelProps={{
            style: { pointerEvents: 'auto' },
          }}
          id="password"
          label="Senha"
          variant="outlined"
          name="password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          InputLabelProps={{
            style: { pointerEvents: 'auto' },
          }}
          id="confirm_password"
          label="Confirmar senha"
          variant="outlined"
          name="confirm_password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </CardWrapper>
  );
}

export default AccessData;
